import Assign from "./assign/assign.store";
import Remove from "./remove/remove.store";
import List from "./list/list.store";
import Transfer from "./transfer/transfer.store";

export default {
  modules: { Assign, Remove, List, Transfer },
};
